import Comps from '@owenscorning/react-library';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import styles from '../../shared/warranty-registration.module.scss';
import { hideModal, setFormData, incrementStep } from '../redux/action.js';

const { Modal } = Comps.Connect;

const ConfirmnBody = props => {
  const { setFormData, hideModal, incrementStep } = props;

  return (
    <div>
      <h4>Are you trying to submit required documents or photos for an existing claim? </h4>
      <div className={styles.modalFlex}>
        <a
          onClick={() => {
            hideModal();
            setFormData({ showExistingClaimPage: true });
          }}
          data-track="form-advance"
          data-track-form-name="Submit Claim"
          data-track-form-step="step 1 - get started"
          className={`cta ${styles.ctaBtn}`}
        >
          Yes
        </a>
        <a
          onClick={() => {
            hideModal();
            incrementStep();
          }}
          data-track="form-advance"
          data-track-form-name="Submit Claim"
          data-track-form-step="step 1 - get started"
          className={`cta ${styles.ctaBtn}`}
        >
          No
        </a>
      </div>
    </div>
  );
};

const GetStartedModal = props => (
  <Modal onClose={props.hideModal} open={props.showModal} className={styles.addressVerificationModal}>
    <ConfirmnBody {...props} />
  </Modal>
);

const mapStateToProps = state => ({
  showModal: state.showModal,
});
const mapDispatchToProps = dispatch => ({
  hideModal: () => dispatch(hideModal()),
  setFormData: hash => dispatch(setFormData(hash)),
  incrementStep: () => dispatch(incrementStep()),
});

export default connect(mapStateToProps, mapDispatchToProps)(GetStartedModal);
